import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormControl } from '@angular/forms';
import { InjectionDataModel } from '../_models/injection-data-model';

@Component({
  selector: 'app-fluid-fraction-form',
  templateUrl: './fluid-fraction-form.component.html',
  styleUrls: ['./fluid-fraction-form.component.css']
})
export class FluidFractionFormComponent implements OnInit {

  @Input() injectionDataModel: InjectionDataModel;

  form: FormGroup;

  FractionSaltWater: number;
  FractionFreshWater: number;
  FractionFractureWaterFlowBack: number;
  FractionNorm: number;
  FractionCo2: number;
  FractionNaturalGas: number;
  FractionH2s: number;
  FractionPolymer: number;
  FractionSteam: number;
  FractionAir: number;
  FractionNitrogen: number;
  FractionOther: number;
  OtherDesc: string;

  constructor(private formBuilder: FormBuilder) {

    
  }

  ngOnInit(): void {

    function totalFractionValidator() {
      return (group: FormGroup): { [key: string]: any } => {
        var ret: any = {
        };

        var keys = Object.keys(group.controls);

        var sum = 0;
        var hasValues = false;

        for (var i = 0; i < keys.length; i++) {
          if (group.controls[keys[i]].value != null && keys[i] != "OtherDesc") {
            hasValues = true;
            sum += group.controls[keys[i]].value;
          }
        }

        if (hasValues && sum != 100) {
          ret.notEquals100 = true;
          ret.totalPercentages = sum;
        }

        if (group.controls.FractionOther.value != null &&
          group.controls.FractionOther.value != 0 &&
          (group.controls.OtherDesc.value == null ||
            group.controls.OtherDesc.value == "")) {
          ret.noOtherDesc = true;
        }

        return ret;
      };
    }

    function individualFractionValidator() {
      return (control: FormControl): {
        [key: string]: any
      } => {
        var ret: any = {
        };

        if (control.value != null && control.value > 100) {
          ret.greaterThan100 = true;
        }

        return ret;
      };
    }

    this.form = this.formBuilder.group({
      'FractionSaltWater': [this.injectionDataModel.FractionSaltWater, individualFractionValidator()],
      'FractionFreshWater': [this.injectionDataModel.FractionFreshWater, individualFractionValidator()],
      'FractionFractureWaterFlowBack': [this.injectionDataModel.FractionFractureWaterFlowBack, individualFractionValidator()],
      'FractionNorm': [this.injectionDataModel.FractionNorm, individualFractionValidator()],
      'FractionCo2': [this.injectionDataModel.FractionCo2, individualFractionValidator()],
      'FractionNaturalGas': [this.injectionDataModel.FractionNaturalGas, individualFractionValidator()],
      'FractionH2s': [this.injectionDataModel.FractionH2s, individualFractionValidator()],
      'FractionPolymer': [this.injectionDataModel.FractionPolymer, individualFractionValidator()],
      'FractionSteam': [this.injectionDataModel.FractionSteam, individualFractionValidator()],
      'FractionAir': [this.injectionDataModel.FractionAir, individualFractionValidator()],
      'FractionNitrogen': [this.injectionDataModel.FractionNitrogen, individualFractionValidator()],
      'FractionOther': [this.injectionDataModel.FractionOther, individualFractionValidator()],
      'OtherDesc': [this.injectionDataModel.OtherDesc]
    }, {
      validator: totalFractionValidator()
    });
  }

}
